module.exports = __webpack_public_path__ + "static/media/MandyAsagba.f2de3d52.png";